
/** treatRecentAccessDateAsSafe (was false), but made true for hot fix for QuotaExceedsUsage Error blockers
 * The side-effect of this will be that users with small quotas will tend to download videos downloaded
 * in the last hour, which is not ideal, but better than blocking for an hour.
 * This is a temporary fix until we can implement a more robust solution.
 * @see https://github.com/ubsicap/sltt/issues/1203
*/
export const HOTFIX_UNBLOCK_CACHE_CLEAN_RECENT_BLOBS = true
